/* This file is generated by vega-design 2.0.71 */
/* eslint-disable */
/* tslint:disable */
// prettier-ignore
const Breakpoints = {
  "S": 320,
  "M": 768,
  "L": 1024,
  "XL": 1440
};

export { Breakpoints as B };
